// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lgprZ","footer":"styles_footer__3w-hR","passCodeTooltip":"styles_passCodeTooltip__3ZBwj"};